import { render } from "./ModernDialog.vue?vue&type=template&id=2936d1e6&scoped=true&ts=true"
import script from "./ModernDialog.vue?vue&type=script&lang=ts"
export * from "./ModernDialog.vue?vue&type=script&lang=ts"

import "./ModernDialog.vue?vue&type=style&index=0&id=2936d1e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2936d1e6"]])

export default __exports__